export default __webpack_public_path__ + "static/media/Truck_icon.1eec5566.svg";